import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";
import {NgIf} from "@angular/common";
import {DbTextPipe} from "../../../../../../../shared/pipes/db-text.pipe";


@Component({
    selector: 'db-contact-edit-modal',
    templateUrl: './approve-edit-modal.component.html',
    imports: [
        NgIf,
        DbTextPipe
    ],
    styleUrls: ['./approve-edit-modal.component.scss']
})
export class ApproveEditModalComponent implements OnInit {
  @Input() modalValue;

  constructor(public activeModal: DbActiveModal) {
  }

  ngOnInit() {
  }

}
